import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgSearchFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.62 15.791a9 9 0 1 0-2.828 2.828l2.794 2.795a2 2 0 1 0 2.828-2.828l-2.794-2.794ZM11 16a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z", fill: color }));
};
export default factorySvgIcon(SvgSearchFilled);
//# sourceMappingURL=SvgSearchFilled.js.map